var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showVideoBox)?_c('div',{staticClass:"videoBox"},[_c('video',{attrs:{"id":"videoDOM","controls":"controls","autoplay":"","src":require("@/assets/images/bannerVideoNew2.mp4"),"type":"video/mp4"}}),_vm._v(" "),_c('a',{staticClass:"videoClose",on:{"click":_vm.videoClose}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91245efe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoBox.vue
// module id = null
// module chunks = 